/**
 * @generated SignedSource<<37c17df32ec93627fb2b364b890ab118>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SimpleMenuMainNavigation_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderAuthenticatedUser_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": "__isViewer"
};

node.hash = "6da48843376ee906fd6e1a332f55ef51";

module.exports = node;
